import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const onboardingApi = createApi({
  reducerPath: 'onboardingApi',
  baseQuery: (args, api, extraOptions) => {
    const adjustedArgs = typeof args === 'string' ? `/onboarding${args}` : { ...args, url: `/onboarding${args.url}` };
    return baseQueryWithReauth(adjustedArgs, api, extraOptions);
  },
  tagTypes: ['Offer', 'Onboarding'],
  endpoints: (builder) => ({
    // Get offer details by token and offerId
    getOfferDetails: builder.query({
      query: ({ token, offerId }) => ({
        url: `/offer-details`,
        method: 'GET',
        params: { token, offerId },
      }),
      providesTags: ['Offer'],
    }),
    
    // Submit offer response (accept/reject)
    offerResponse: builder.mutation({
      query: (data) => ({
        url: '/offer-response',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Offer'],
    }),
    
    // Get onboarding status for an employee
    getOnboardingStatus: builder.query({
      query: (employeeId) => `/status/${employeeId}`,
      providesTags: ['Onboarding'],
    }),
    
    // Update onboarding step
    updateOnboardingStep: builder.mutation({
      query: ({ employeeId, step, data }) => ({
        url: `/update-step/${employeeId}`,
        method: 'POST',
        body: { step, data },
      }),
      invalidatesTags: ['Onboarding'],
    }),
    
    // Get onboarding checklist
    getOnboardingChecklist: builder.query({
      query: (employeeId) => `/checklist/${employeeId}`,
      providesTags: ['Onboarding'],
    }),
    
    // Submit onboarding documents
    submitOnboardingDocuments: builder.mutation({
      query: ({ employeeId, documents }) => ({
        url: `/submit-documents/${employeeId}`,
        method: 'POST',
        body: documents,
      }),
      invalidatesTags: ['Onboarding'],
    }),
  }),
});

export const {
  useGetOfferDetailsQuery,
  useOfferResponseMutation,
  useGetOnboardingStatusQuery,
  useUpdateOnboardingStepMutation,
  useGetOnboardingChecklistQuery,
  useSubmitOnboardingDocumentsMutation,
} = onboardingApi;
